import React from 'react';
import styles from './Loader.scss';
import Section from './Section';

const Loader = ({ label }) => (
	<Section>
		<div className={styles.root}>
			{label && <h6 className={styles.label}>{label}</h6>}
		</div>
	</Section>
);
export default Loader;



// WEBPACK FOOTER //
// ./src/ui/components/Loader.js